import faker from 'faker';
import PageContainer from './PageContainer';
import Draft from '../models/Draft';
import DraftSession from '../models/DraftSession';
import mockTemplates from './__mocks__/templates.json';

export default class ListingPage extends PageContainer {
  state = {
    activeTab: '1',
    cardsInfo: [
      {
        _id: "5bbf13641cb0e50468900ecc",
        title: "Instant Gratification",
        blurb: "Is it really in our best interest to get everything our heart desires?",
        image: null,
        template: {
          name: "Issue",
          _id: "5bcd350cb2076b0bd4597b81s",
        },
      },
      {
        _id: "5bcd2663b8f73e0af8c24e63",
        title: "Is Social Media Dangerous to Democracy?",
        blurb: "A healthy democracy requires a well-informed citizenry but social media seems rife with propaganda and weaponized information.",
        image: "https://cdn-images-1.medium.com/max/2000/1*ETTTTDXfXLRN0WRMvmnOJA.png",
        template: {
          name: "Issue",
          _id: "5b8dd4d52c17811cca258652",
        },
      },
      {
        _id: "5bcd350cb2076b0bd4597b81",
        title: "Unconditional Love",
        blurb: "The bond between mother and child is held to the highest standard, yet relationships without boundaries can lead to abuse.",
        image: "https://karolinapatryk.com/wp-content/uploads/2018/04/unconditional-love-does-it-even-exist.jpg",
        template: {
          name: "Resolution",
          _id: "5bcd350cb2076b0bd4597b81",
        },
      },
    ],
    allowedDisplayedCardToParticipant: [],
    template: null,
    draft: null,
    sessionNumber: 2,
    draftSessions: {
      next: null,
      current: null,
      completed: [],
      remaining: [],
    },
    createdBy: {
      displayName: faker.name.findName(),
      image: faker.image.avatar(),
    },
    hideEndedSession: true,
    modal: false,
  }

  options = {
    getFromSession: ['template', 'draftSessions', 'draft'],
    defaultState: {
      template: (mockTemplates || []).filter(t => /Issue/i.test(t.name)).pop(),
      draft: Draft.mock(),

      draftSessions: {
        next: DraftSession.mock(),
        current: DraftSession.mock(),
        completed: [DraftSession.mock()],
        remaining: [DraftSession.mock()],
      },
    },
    flags: [{
      name: 'isLoaded',
      check: () => true,
    }],
  }

  async setup() {
    await this.subscribeToSession();

    if (!(this.state.draft && this.state.template)) {
      return this.setState(this.options.defaultState);
    }
  }

  destroy() {
    this.unsubscribeAll();
  }

  toggle = (tab) => {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab,
      });
    }
  }

  handleOnClickCard = () => {
    console.log("ssss")
  }

  constructor(props) {
    super(props);
    this.getPropsFromSession(this.options.getFromSession);
    this.setupFlags(this.options.flags);
  }
}



// WEBPACK FOOTER //
// ./src/containers/ListingContainer.js